import { useCallback } from 'react';
import { api } from '../api/client';
import { JobPostingDto } from '../types/jobPostingDto';
import { JobPostingRequest } from '../types/jobPostingRequest';

export const useJobPostingService = () => {
    const createJobPosting = useCallback(async (request: JobPostingRequest): Promise<JobPostingDto> => {
        const response = await api.post('/api/users/job-postings', request);
        return response.data;
    }, []);

    return { createJobPosting };
};
